import { optionalPositiveInteger, optionalTrimmedString } from '../../../lib/routeSearch';
import { AdsTxtAppsFoundCriteria, type AdsTxtAppsFilter } from './model';

export interface AdsTxtAppsRouteSearch {
  search?: string;
  publishers?: string;
  found?: string;
  page?: number;
  size?: number;
}

const defaultAdsTxtAppsFilter: AdsTxtAppsFilter = {
  searchTerm: '',
  publisherIds: [],
  foundCriteria: AdsTxtAppsFoundCriteria.AllApps,
  page: 0,
  size: 10,
};

export function adsTxtAppsRouteSearchSchema(search: Record<string, unknown>) {
  const searchTerm = optionalTrimmedString(search['search']);
  const publishers = typeof search['publishers'] === 'string' ? search['publishers'] : undefined;
  const found = optionalTrimmedString(search['found']);
  const page = optionalPositiveInteger(search['page']);
  const size = optionalPositiveInteger(search['size']);
  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(publishers ? { publishers } : {}),
    ...(found ? { found } : {}),
    ...(page ? { page } : {}),
    ...(size ? { size } : {}),
  } satisfies AdsTxtAppsRouteSearch;
}

export function parseAdsTxtAppsRouteSearch(search: AdsTxtAppsRouteSearch): AdsTxtAppsFilter {
  const foundCriteria = Object.values(AdsTxtAppsFoundCriteria).includes(
    search.found as AdsTxtAppsFoundCriteria,
  )
    ? (search.found as AdsTxtAppsFoundCriteria)
    : AdsTxtAppsFoundCriteria.AllApps;
  return {
    searchTerm: search.search ?? '',
    publisherIds:
      search.publishers
        ?.split(',')
        .map((id) => id.trim())
        .filter(Boolean) ?? [],
    foundCriteria,
    page: search.page ? search.page - 1 : 0,
    size: search.size ?? defaultAdsTxtAppsFilter.size,
  };
}

export function serializeAdsTxtAppsRouteSearch(filter: AdsTxtAppsFilter): AdsTxtAppsRouteSearch {
  return {
    ...(filter.searchTerm.trim() ? { search: filter.searchTerm.trim() } : {}),
    ...(filter.publisherIds.length ? { publishers: filter.publisherIds.join(',') } : {}),
    ...(filter.foundCriteria !== AdsTxtAppsFoundCriteria.AllApps
      ? { found: filter.foundCriteria }
      : {}),
    ...(filter.page ? { page: filter.page + 1 } : {}),
    ...(filter.size !== defaultAdsTxtAppsFilter.size ? { size: filter.size } : {}),
  };
}
